<template>
  <b-sidebar
    id="pages-form-sidebar"
    :visible="isPagesFormSidebarActive"
    bg-variant="white"
    sidebar-class="sidebar-lg"
    shadow
    backdrop
    no-header
    right
    @shown="getData(pagesData)"
    @hidden="resetForm"
    @change="(val) => $emit('update:is-pages-form-sidebar-active', val)"
  >
  <template #default="{ hide }">
    <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
      <h5 class="mb-0">
        Page  Form
      </h5>
      <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="hide"
      />
    </div>
    <validation-observer v-slot="{ validate }" ref="formObserver">
      <b-form 
        @submit.prevent="onSubmit(true)" 
        @reset.prevent="resetForm"
        class="p-2"
      >
        <b-tabs v-model="tabIndex">
          <b-tab title="Content">
            <b-tabs content-class="mt-1" v-if="langs.length > 0">
              <b-tab
                v-for="(lang, key) in langs"
                :key="'tab-' + key"
                :title="lang.name"
              >
                <validation-provider
                  v-slot="{errors, validate}"
                  :name="'Title_' + lang.code"
                  rules="required"
                >
                  <b-form-group
                    label="Name"
                    :label-for="'name_' + lang.code"
                  >
                    <b-form-input
                      :id="'name_' + lang.code"
                      v-model="Data.title[lang.code]"
                      autofocus
                      :state="errors[0] ? false : null"
                      trim
                      :placeholder="'name (' + lang.code + ')'"
                      @input="(value) => { validate(); changeTitle(lang.code, value); }"
                    />
                    <b-form-invalid-feedback>
                      {{ errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
                <validation-provider
                  v-slot="{errors, validate}"
                  :name="'slug_' + lang.code"
                  rules="required"
                >
                  <b-form-group
                    label="Slug"
                    :label-for="'slug_' + lang.code"
                  >
                    <b-form-input
                      :id="'slug_' + lang.code"
                      v-model="Data.slug[lang.code]"
                      autofocus
                      :state="errors[0] ? false : null"
                      trim
                      :placeholder="'slug (' + lang.code + ')'"
                      @input="validate"
                    />
                    <b-form-invalid-feedback>
                      {{ errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-tab>
            </b-tabs>
            <validation-provider
              v-slot="{errors, validate}"
              name="short_description"
              rules="min:0"
            >
              <b-form-group
                label="Short Description"
                label-for="short_description"
              >
                <b-form-textarea 
                  v-model="Data.short_description" 
                  @input="validate"
                />
                <b-form-invalid-feedback>
                  {{ errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
            <form-repeater-basic 
              v-if="isPagesFormSidebarActive == true &&  !loading && Data.id" 
              :page-input-repeater-remove.sync="PageInputRepeaterRemove"  
              :page-input-repeater.sync="PageInputRepeater" 
              @onChangeOrdering="changeOrdering" 
              @onSubmit="onSubmit"
            />
            <validation-provider
              v-slot="{errors, validate}"
              name="IsActive"
              rules="required"
            >
              <b-form-group label="Is Active" label-for="IsActive">
                <b-form-checkbox
                  id="isactive"
                  checked="true"
                  class="custom-control-success"
                  v-model="Data.is_active"
                  switch
                  @input="validate"
                />
                <b-form-invalid-feedback>
                  {{ errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>
          </b-tab>
          <b-tab title="SEO">
            <validation-provider
              v-slot="{errors, validate}"
              name="meta_title"
              rules="min:0"
            >
              <b-form-group
                label="Meta Title"
                label-for="meta_title"
              >
                <b-form-input
                  id="meta_title"
                  v-model="Data.meta_title"
                  autofocus
                  trim
                  placeholder="Meta Title"
                  @input="validate"
                />
                <b-form-invalid-feedback>
                    {{ errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider> 
            <validation-provider
              v-slot="{errors, validate}"
              name="meta_description"
              rules="min:0"
            >
              <b-form-group
                label="Meta Description"
                label-for="meta_description"
              >
                <b-form-input
                  id="meta_description"
                  v-model="Data.meta_description"
                  autofocus
                  trim
                  placeholder="Meta Description"
                  @input="validate"
                />
                <b-form-invalid-feedback>
                    {{ errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>   
            <validation-provider
              v-slot="{errors, validate}"
              name="meta_keywords"
              rules="min:0"
            >
              <b-form-group
                label="Meta Keywords"
                label-for="meta_keywords"
              >
                <b-form-input
                  id="meta_keywords"
                  v-model="Data.meta_keywords"
                  autofocus
                  trim
                  placeholder="Meta Keywords"
                  @input="validate"
                />
                <b-form-invalid-feedback>
                  {{ errors[0] }}
                </b-form-invalid-feedback>
              </b-form-group>
            </validation-provider>      
          </b-tab>
        </b-tabs>
        <div class="d-flex mt-2">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="mr-2"
            type="submit"
          >
            Save
          </b-button>
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            type="button"
            variant="outline-secondary"
            @click="hide"
          >
            Cancel
          </b-button>
        </div>
      </b-form>
    </validation-observer>
  </template>
</b-sidebar>
</template>

<script>
import { $themeConfig } from '@themeConfig'
import {
  BSidebar, BForm, BFormGroup, BFormInput, BFormTextarea, BFormCheckbox, BFormInvalidFeedback, BButton,BTabs, BTab,
  BCardText, BMedia, BMediaAside, BMediaBody, BAvatar, BImg, BLink, BFormFile
} from 'bootstrap-vue'
import { useInputImageRenderer } from '@core/comp-functions/forms/form-utils'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required, alphaNum, email, password,confirmed } from '@validations'
import formValidation from '@core/comp-functions/forms/form-validation'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import countries from '@/@fake-db/data/other/countries'
import store from '@/store'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { useToast } from 'vue-toastification/composition'
import 'quill/dist/quill.core.css'
// eslint-disable-next-line
import 'quill/dist/quill.snow.css'
// eslint-disable-next-line
import 'quill/dist/quill.bubble.css'
import { slugify } from '@/@fake-db/utils'
import { quillEditor } from 'vue-quill-editor'
import { ref, onUnmounted, reactive } from "@vue/composition-api";
import FormRepeaterBasic from './FormRepeaterBasic.vue'
import languagesStoreModule from '@/views/languages/languagesStoreModule'

export default {
  components: {
    BSidebar, BForm, BFormGroup, BFormInput, BFormTextarea, BFormCheckbox, BFormInvalidFeedback,
    BButton, BTabs, BTab, BCardText, BMedia, BMediaAside, BMediaBody, BAvatar, BImg, BLink, 
    vSelect, quillEditor, FormRepeaterBasic, ValidationProvider, ValidationObserver, BFormFile,
  },

  directives: {
    Ripple,
  },

  model: {
    prop: 'isPagesFormSidebarActive',
    event: 'update:is-pages-form-sidebar-active',
  },

  props: {
    isPagesFormSidebarActive: {
      type: Boolean,
      required: true,
    },
    pagesData: {
      type: Object,
      required: false,
    },
    pagesList: {
      type: Array,
      required: false,
    }
  },

  setup(props, { emit }) {
    const LANGUAGES_STORE_MODULE_NAME = "app-languages";
    if (!store.hasModule(LANGUAGES_STORE_MODULE_NAME)) store.registerModule(LANGUAGES_STORE_MODULE_NAME, languagesStoreModule);
    onUnmounted(() => {
      if (store.hasModule(LANGUAGES_STORE_MODULE_NAME)) store.unregisterModule(LANGUAGES_STORE_MODULE_NAME);
    });

    const {  appRef } = $themeConfig.app
    const toast = useToast()
    const loading = ref(true);
    const tabIndex = ref(0);
    const featuredImage = ref({});
    const userStorage = JSON.parse(localStorage.getItem('userData'));
    const repeaters = {
      id:'',
      component: '',
      image:'',
      title:'',
      description:'',
      show:true
    }
    const PageInputRepeaterRemove = ref([]);
    const PageInputRepeater = ref([]);
    const getLocalSite = JSON.parse(localStorage.getItem('site'))
    const blankData = reactive({
      featuredImage:require('@/assets/images/no-image.png'),
      icon:'',
      created_by: userStorage.id,
      created_at: null,
      title: {},
      slug:{},
      short_description:'',
      description:'',
      is_active:true,
      pagesFile:null,
      banner_image:'',
      meta_title:'',
      meta_description:'',
      meta_keywords:'',
      sites_id: getLocalSite.id,
    })
    const Data = ref(blankData)
    const langs = ref([])
    const formObserver = ref(null);
    const isClose = ref(true)

    const resetData = () => {
      Data.value = JSON.parse(JSON.stringify(blankData))
    }
 
    const getData = (data)=>{
      loading.value = true;
      tabIndex.value = 0;
      PageInputRepeater.value = [];
          
      if(data){
          PageInputRepeater.value = data.contents;
          data.featuredImage = data.banner_image?data.fullpath:Data.value.featuredImage;
          data.is_active = data.is_active?true:false;
          Data.value  = JSON.parse(JSON.stringify(data));
      }

      setTimeout(function() { loading.value = false; }, 100);
    }

    const getRefesh = ()=>{
      let currentPage  = props.pagesList.filter(v=>v.id==Data.value.id);
      tabIndex.value = 0;
      PageInputRepeater.value = [];
      Data.value  = {}
      if(currentPage[0]){
          PageInputRepeater.value = currentPage[0].contents;
          currentPage[0].featuredImage = currentPage[0].banner_image?data.fullpath:Data.value.featuredImage;
          currentPage[0].is_active = currentPage[0].is_active?true:false;
          Data.value  = JSON.parse(JSON.stringify(currentPage[0]));
      }
      
      setTimeout(function() { loading.value = false; }, 100);
    
    }

    const onSubmit = async (data) => {
      isClose.value = data
      if (formObserver.value) {
        const isValid = await formObserver.value.validate();

        if (!isValid) {
          const errorMessages = Object.entries(formObserver.value.errors)
            .filter(([key, message]) => message.length)
            .map(([key, message]) => `${message}`)

          toast({
            component: ToastificationContent,
            position: 'top-right',
            props: {
              title: `Error`,
              icon: 'BellIcon',
              variant: 'danger',
              text: `${errorMessages.join(" , ")}`,
            },
          });

          return
        }
      }

      let formData = new FormData();
      Data.value.is_active = Data.value.is_active?1:0;
      Data.value.path = '/var/www/html/uploadfiles/uploads/'+appRef+'/pages/';
      Data.value.savepath = 'uploads/'+appRef+'/pages/';
      Data.value.contents = [];
      Data.value.contents_remove = [];
         
      if(PageInputRepeater.value.length > 0){
        Data.value.contents = JSON.stringify(PageInputRepeater.value );
      }

      if(PageInputRepeaterRemove.value.length > 0){
        Data.value.contents_remove = JSON.stringify(PageInputRepeaterRemove.value );
      }
          
      for(const [key, value] of Object.entries(Data.value)) {
        formData.append(key, value);
      }
         
      if(Data.value.id){
        formData.append('data', JSON.stringify(Data.value))

        store.dispatch('app-pages/updateData', {formData:formData, data:Data.value})
          .then((res) => {

            if(res.data.success){
              emit('refetch-data')
              if(isClose.value){
                toast({
                  component: ToastificationContent,
                  position: 'top-right',
                  props: {
                    title: `Success`,
                    icon: 'BellIcon',
                    variant: 'success',
                    text: `done`,
                  },
                });
                emit('update:is-pages-form-sidebar-active', false)
                isClose.value = false
              } else {
                loading.value = true
                setTimeout(function() { getRefesh();}, 500);
              }
            } else {
              toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                  title: `Error`,
                  icon: 'BellIcon',
                  variant: 'danger',
                  text: `${res.data.message}`,
                },
              });
            }
          }
        )
      } else {
        formData.append('data', JSON.stringify(Data.value))

        store.dispatch('app-pages/addData', {formData:formData})
          .then((res) => {
            if(res.data.success){
              toast({
                  component: ToastificationContent,
                  position: 'top-right',
                  props: {
                    title: `Success`,
                    icon: 'BellIcon',
                    variant: 'success',
                    text: `${res.data.message}`,
                  },
              });

              emit('refetch-data')
              emit('update:is-pages-form-sidebar-active', false)
            } else {
              toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                  title: `Error`,
                  icon: 'BellIcon',
                  variant: 'danger',
                  text: `${res.data.message}`,
                },
              });
            }
          }
        )
      }
    }

    const {
      refFormObserver,
      getValidationState,
      // resetForm,
    } = formValidation(resetData)

    //upload
    const refInputEl = ref(null)
    const refPreviewEl = ref(null)

    const { inputImageRenderer } = useInputImageRenderer(refInputEl, base64 => {
      refPreviewEl.value.src = base64 
    })

    const revomeImage = ()=>{
      Data.value.featuredImage = require('@/assets/images/no-image.png');
      Data.value.cover_image = '';
    }

    const changeTitle  = (langCode, value) => {
      Data.value.slug[langCode] =  slugify(value)
    }
     
    const changeOrdering = (item)=>{
      loading.value = true;
      PageInputRepeater.value = item;
      setTimeout(function() { loading.value = false; }, 500);
    }

    const refeshList = async () => {
      emit("refetch-data");
    };

    const getLangs = (filter) => {
      store.dispatch("app-languages/fetchData", filter).then((res) => {
        if (res.data.success) {
            langs.value = res.data.data;
        }
      });
    };

    let filter = {
      is_active:1,
    }

    getLangs(filter)

    const resetForm = () => {
      Data.value = blankData
      formObserver.value.reset()
    }

    return {
      Data,
      onSubmit,
      PageInputRepeaterRemove,
      PageInputRepeater,
      refFormObserver,
      getValidationState,
      resetForm,
      getData,
      tabIndex,
      refInputEl,
      refPreviewEl,
      inputImageRenderer,
      revomeImage,
      changeTitle,
      loading,
      changeOrdering,
      refeshList,
      getRefesh,
      langs,
      formObserver,
      isClose,
    }
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/quill.scss';
</style>